/*jshint -W069 */
/**
 * 
 * @class Api
 * @param {(string|object)} [domainOrOptions] - The project domain or options object. If object, see the object's optional properties.
 * @param {string} [domainOrOptions.domain] - The project domain
 * @param {object} [domainOrOptions.token] - auth token - object with value property and optional headerOrQueryName and isQuery properties
 */
var Api = (function() {
    'use strict';

    var Q = require('q');
    var settingsInstance = require('./SettingsInstance.js');
    var customRequest = require('./requestHelper.js').customRequest;
    var mergeQueryParams = require('./requestHelper.js').mergeQueryParams;

    function Api(options) {
        var domain = (typeof options === 'object') ? options.domain : options;
        this.domain = domain ? domain : settingsInstance.baseApiUrl;
        if (this.domain.length === 0) {
            throw new Error('Domain parameter must be specified as a string.');
        }
    }

    /**
     * HTTP Request
     * @method
     * @name Api#request
     * @param {string} method - http method
     * @param {string} path - path
     * @param {string} url
     * @param {object} body - body parameters / object
     * @param {object} headers - header parameters
     * @param {object} queryParameters - querystring parameters
     * @param {object} form - form data object
     * @param {object} deferred - promise object
     */
    Api.prototype.request = customRequest;

    /**
     * Usuń zasilenia masowe
     * @method
     * @name Api#deleteZasileniaMasowe
     * @param {object} parameters - method options and parameters
     * @param {} parameters.body - 
     * @param {string} parameters.token - Token
     */
    Api.prototype.deleteZasileniaMasowe = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/zasilenia_masowe',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/json'];

        if (parameters['body'] !== undefined) {
            body = parameters['body'];
        }

        if (parameters['body'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: body'));
            return deferred.promise;
        }

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('DELETE', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    /**
     * Pobierz zasilenia masowe
     * @method
     * @name Api#getZasileniaMasowe
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.token - Token
     * @param {string} parameters.page_number - Numer strony (domyślnie None - zwracana całość)
     * @param {string} parameters.items_per_page - Ilość elementów na stronę (domyślnie None - zwracana całość)
     * @param {string} parameters.order_by - Wg której kolumny sortowanie (domyślnie id)
     * @param {boolean} parameters.desc - Czy sortowanie zstępne
     * @param {string} parameters.filter_str - Treść filtra
     * @param {string} parameters.filter_typ - Filtrowanie po nazwie typu (styl typeahead)
     * @param {string} parameters.typ - Filtrowanie po zgodnym typie
     * @param {string} parameters.control - Parametr kontrolny
     */
    Api.prototype.getZasileniaMasowe = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/zasilenia_masowe',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/json'];

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        if (parameters['page_number'] !== undefined) {
            queryParameters['page_number'] = parameters['page_number'];
        }

        if (parameters['items_per_page'] !== undefined) {
            queryParameters['items_per_page'] = parameters['items_per_page'];
        }

        if (parameters['order_by'] !== undefined) {
            queryParameters['order_by'] = parameters['order_by'];
        }

        if (parameters['desc'] !== undefined) {
            queryParameters['desc'] = parameters['desc'];
        }

        if (parameters['filter_str'] !== undefined) {
            queryParameters['filter_str'] = parameters['filter_str'];
        }

        if (parameters['filter_typ'] !== undefined) {
            queryParameters['filter_typ'] = parameters['filter_typ'];
        }

        if (parameters['typ'] !== undefined) {
            queryParameters['typ'] = parameters['typ'];
        }

        if (parameters['control'] !== undefined) {
            queryParameters['control'] = parameters['control'];
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('GET', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    /**
     * Dodaj zasilenie masowe
     * @method
     * @name Api#postZasileniaMasowe
     * @param {object} parameters - method options and parameters
     * @param {} parameters.body - 
     * @param {string} parameters.token - Token
     */
    Api.prototype.postZasileniaMasowe = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/zasilenia_masowe',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/json'];

        if (parameters['body'] !== undefined) {
            body = parameters['body'];
        }

        if (parameters['body'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: body'));
            return deferred.promise;
        }

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('POST', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    /**
     * Pobierz zasilenie masowe
     * @method
     * @name Api#getZasileniaMasoweById
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.token - Token
     * @param {string} parameters.id - ID
     * @param {string} parameters.control - Parametr kontrolny
     */
    Api.prototype.getZasileniaMasoweById = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/zasilenia_masowe/{id}',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/json'];

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        parameterPath = parameterPath.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        if (parameters['control'] !== undefined) {
            queryParameters['control'] = parameters['control'];
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('GET', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    /**
     * Edytuj zasilenie masowe
     * @method
     * @name Api#putZasileniaMasoweById
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.id - ID zasilenie masowe
     * @param {} parameters.body - 
     * @param {string} parameters.token - Token
     */
    Api.prototype.putZasileniaMasoweById = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/zasilenia_masowe/{id}',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/json'];

        parameterPath = parameterPath.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        if (parameters['body'] !== undefined) {
            body = parameters['body'];
        }

        if (parameters['body'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: body'));
            return deferred.promise;
        }

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('PUT', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    /**
     * Sprawdź status pobierania pliku do zasilenia masowego
     * @method
     * @name Api#getZasileniaMasoweByIdPostep
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.token - Token
     * @param {string} parameters.id - ID zasilenia masowego
     */
    Api.prototype.getZasileniaMasoweByIdPostep = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/zasilenia_masowe/{id}/postep',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/json'];

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        parameterPath = parameterPath.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('GET', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    /**
     * Dodaj plan zasilenia masowego
     * @method
     * @name Api#postZasileniaPlan
     * @param {object} parameters - method options and parameters
     * @param {} parameters.body - 
     * @param {string} parameters.token - Token
     */
    Api.prototype.postZasileniaPlan = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/zasilenia_plan',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/json'];

        if (parameters['body'] !== undefined) {
            body = parameters['body'];
        }

        if (parameters['body'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: body'));
            return deferred.promise;
        }

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('POST', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    /**
     * Dodaj plik w zasileniu manualnym
     * @method
     * @name Api#postZasilenieManualne
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.token - Token
     * @param {file} parameters.file - Plik
     * @param {file} parameters.file2 - Plik
     * @param {file} parameters.file3 - Plik
     * @param {file} parameters.file4 - Plik
     * @param {string} parameters.format - Format pliku
     * @param {string} parameters.kodowanie - Kodowanie znaków (utf-8, windows-1250, iso-8859-2)
     * @param {string} parameters.id_warstwa - Id warstwy
     */
    Api.prototype.postZasilenieManualne = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/zasilenie_manualne',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/json'];

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        if (parameters['file'] !== undefined) {
            files['file'] = parameters['file'];
        }

        if (parameters['file'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: file'));
            return deferred.promise;
        }

        if (parameters['file2'] !== undefined) {
            files['file2'] = parameters['file2'];
        }

        if (parameters['file3'] !== undefined) {
            files['file3'] = parameters['file3'];
        }

        if (parameters['file4'] !== undefined) {
            files['file4'] = parameters['file4'];
        }

        if (parameters['format'] !== undefined) {
            form['format'] = parameters['format'];
        }

        if (parameters['format'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: format'));
            return deferred.promise;
        }

        if (parameters['kodowanie'] !== undefined) {
            form['kodowanie'] = parameters['kodowanie'];
        }

        if (parameters['kodowanie'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: kodowanie'));
            return deferred.promise;
        }

        if (parameters['id_warstwa'] !== undefined) {
            form['id_warstwa'] = parameters['id_warstwa'];
        }

        if (parameters['id_warstwa'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id_warstwa'));
            return deferred.promise;
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('POST', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    /**
     * Usuń zasilenia manualne
     * @method
     * @name Api#deleteZasilenieManualneById
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.id - ID
     * @param {string} parameters.token - Token
     */
    Api.prototype.deleteZasilenieManualneById = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/zasilenie_manualne/{id}',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/json'];

        parameterPath = parameterPath.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('DELETE', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    /**
     * Pobierz zasilenie manualne
     * @method
     * @name Api#getZasilenieManualneById
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.token - Token
     * @param {string} parameters.id - ID
     * @param {string} parameters.control - Parametr kontrolny
     */
    Api.prototype.getZasilenieManualneById = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/zasilenie_manualne/{id}',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/json'];

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        parameterPath = parameterPath.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        if (parameters['control'] !== undefined) {
            queryParameters['control'] = parameters['control'];
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('GET', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    /**
     * Edytuj zasilenie masowe
     * @method
     * @name Api#putZasilenieManualneById
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.id - ID zasilenie masowe
     * @param {} parameters.body - 
     * @param {string} parameters.token - Token
     */
    Api.prototype.putZasilenieManualneById = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/zasilenie_manualne/{id}',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/json'];

        parameterPath = parameterPath.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        if (parameters['body'] !== undefined) {
            body = parameters['body'];
        }

        if (parameters['body'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: body'));
            return deferred.promise;
        }

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('PUT', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    /**
     * Cofnij zasilenia do parametryzacji
     * @method
     * @name Api#postZasilenieManualneByIdCofnijDoParametryzacji
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.id - ID
     * @param {string} parameters.token - Token
     */
    Api.prototype.postZasilenieManualneByIdCofnijDoParametryzacji = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/zasilenie_manualne/{id}/cofnij_do_parametryzacji',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/json'];

        parameterPath = parameterPath.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('POST', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    /**
     * Pobierz informacje o pliku zasilenia
     * @method
     * @name Api#getZasilenieManualneByIdPlik
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.token - Token
     * @param {string} parameters.id - ID
     * @param {string} parameters.control - Parametr kontrolny
     */
    Api.prototype.getZasilenieManualneByIdPlik = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/zasilenie_manualne/{id}/plik',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/json'];

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        parameterPath = parameterPath.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        if (parameters['control'] !== undefined) {
            queryParameters['control'] = parameters['control'];
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('GET', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    /**
     * Edytuj zasilenie manualne - plik
     * @method
     * @name Api#putZasilenieManualneByIdPlik
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.token - Token
     * @param {string} parameters.id - ID
     * @param {file} parameters.file - Plik
     * @param {string} parameters.id_warstwa - Id warstwy
     * @param {string} parameters.warstwa - Nazwa warstwy do wyboru z plików wielowarstwowych
     */
    Api.prototype.putZasilenieManualneByIdPlik = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/zasilenie_manualne/{id}/plik',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/json'];

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        parameterPath = parameterPath.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        if (parameters['file'] !== undefined) {
            files['file'] = parameters['file'];
        }

        if (parameters['id_warstwa'] !== undefined) {
            form['id_warstwa'] = parameters['id_warstwa'];
        }

        if (parameters['warstwa'] !== undefined) {
            form['warstwa'] = parameters['warstwa'];
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('PUT', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    /**
     * Pobierz pliki zasilenie masowego
     * @method
     * @name Api#getZasilenieManualneByIdPliki
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.token - Token
     * @param {string} parameters.id - ID
     */
    Api.prototype.getZasilenieManualneByIdPliki = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/zasilenie_manualne/{id}/pliki',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/octet-stream, application/json'];

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        parameterPath = parameterPath.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('GET', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    /**
     * Pobierz weryfikację zasilenia manualnego
     * @method
     * @name Api#getZasilenieManualneByIdWeryfikacja
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.token - Token
     * @param {string} parameters.id - ID
     * @param {string} parameters.control - Parametr kontrolny
     */
    Api.prototype.getZasilenieManualneByIdWeryfikacja = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/zasilenie_manualne/{id}/weryfikacja',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/json'];

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        parameterPath = parameterPath.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        if (parameters['control'] !== undefined) {
            queryParameters['control'] = parameters['control'];
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('GET', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    /**
     * Zapis zasilenie manualne do nowej sesji
     * @method
     * @name Api#postZasilenieManualneByIdZapisDoSesji
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.token - Token
     * @param {string} parameters.id - Id zasilenia
     */
    Api.prototype.postZasilenieManualneByIdZapisDoSesji = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/zasilenie_manualne/{id}/zapis_do_sesji',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/json'];

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        parameterPath = parameterPath.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('POST', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    /**
     * Pobierz raport zasilenia masowego
     * @method
     * @name Api#getZasilenieMasoweByIdRaport
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.token - Token
     * @param {string} parameters.id - ID
     * @param {string} parameters.control - Parametr kontrolny
     */
    Api.prototype.getZasilenieMasoweByIdRaport = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/zasilenie_masowe/{id}/raport',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/json'];

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        parameterPath = parameterPath.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        if (parameters['control'] !== undefined) {
            queryParameters['control'] = parameters['control'];
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('GET', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    /**
     * Pobierz status zasilenia masowego
     * @method
     * @name Api#getZasilenieMasoweByIdStatus
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.token - Token
     * @param {string} parameters.id - ID
     * @param {string} parameters.control - Parametr kontrolny
     */
    Api.prototype.getZasilenieMasoweByIdStatus = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/zasilenie_masowe/{id}/status',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/json'];

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        parameterPath = parameterPath.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        if (parameters['control'] !== undefined) {
            queryParameters['control'] = parameters['control'];
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('GET', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    /**
     * Zatrzymaj zasilenia masowe
     * @method
     * @name Api#deleteZasilenieMasoweByIdStop
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.id - ID
     * @param {string} parameters.token - Token
     */
    Api.prototype.deleteZasilenieMasoweByIdStop = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/zasilenie_masowe/{id}/stop',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/json'];

        parameterPath = parameterPath.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('DELETE', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    return Api;
})();

exports.Api = Api;